'use client';

import { useLogout } from '@/hooks/use-logout';
import { useEnvironmentContext } from '@/providers/environment.provider';
import { Button } from '@/comps/primitives/button';
import { useRouter } from 'next/navigation';

export function GenericErrorPage() {
  const { logout } = useLogout();
  const { isAuth0 } = useEnvironmentContext();
  const router = useRouter();

  return (
    <div className="fadeIn flex h-screen items-center justify-center">
      <div className="flex w-full max-w-175 flex-col gap-4">
        <h4 className="text-center text-2xl">
          Something went wrong, please refresh the page or try to login with another account
        </h4>

        <div className="flex justify-center gap-2">
          {isAuth0 ? (
            <Button size="lg" onClick={() => logout()}>
              Refresh
            </Button>
          ) : (
            <>
              <Button variant="ghost" size="lg" onClick={() => logout()}>
                Logout
              </Button>
              <Button size="lg" onClick={() => router.push('/')}>
                Refresh
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
